import React, { useRef } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import List from '../../grid.component';
import ActionsToolbar from 'src/components/toolbar.component/actions.toolbar';
const AddressDetails = () => {
  const navigate = useNavigate();
  const { custId } = useParams();
  const gridRef = useRef(null);
  const details = (dataItem) => {
    navigate(`/customer/${custId}/Personal Information/personalInfo/${dataItem.id}`)
  }
  const renderCustomCell = (renderProp, column) => {
    const customcells = {
        "fullname":  (cellProps) => (
        <td>
          <div>
            <button
              className="gridLink c-pointer batch-filename"
              onClick={() => details(cellProps?.dataItem)}
            >
              <span className='pe-2'>{cellProps?.dataItem?.fullname}</span>
              {cellProps?.dataItem?.isDefault && <span className='status-badge bg-light-badgeGreen px-2 rounded-md text-xs  text-[#fff]'>Default</span>}
            </button>
          </div>
        </td>
      ),
    }
    if (customcells[column.field])
        return customcells[column.field](renderProp);
}
  return (
    <div>
      {/* <div>
             <ActionsToolbar screenName={"Customers"} tabName={"Wallets"} />
            </div> */}
      <List
        url={process.env.REACT_APP_API_END_POINT_CARD + `/api/v1/Common/CustomerK/${custId}/Address`}
        className="custom-grid"
        ref={gridRef}
        screenName={"CustomerProfileInfo"}
        renderCustomCell={renderCustomCell}
        sortable={true}
        pSize={5}
      />
    </div>
  )
}
export default AddressDetails